import { render, staticRenderFns } from "./AreasOfInterest.vue?vue&type=template&id=4cb79577&"
import script from "./AreasOfInterest.vue?vue&type=script&lang=js&"
export * from "./AreasOfInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports